import {
    ViewEncapsulation, Component, Input, EventEmitter, Output, ViewChild, OnInit, OnDestroy,
    Inject, Injector, KeyValueDiffer, KeyValueDiffers
}                                  from '@angular/core';
import {
    FormControl,
    FormGroup,
    NG_VALUE_ACCESSOR, RequiredValidator
}                                  from '@angular/forms';
import {OnChange}                  from '@ng-app-framework/core';
import {Observable}                from 'rxjs/Rx';
import {FormConfig}                from '../../Service/FormConfig';
import {NgFormControl}             from '../NgFormControl';
import {RequiredCheckBoxValidator} from '../../Validation/Directive/RequiredCheckBoxValidator';


@Component({
    selector     : 'check-box',
    template     : `
        <ng-container *ngIf="initialized">
            <div class="form-group" [class.validate-input]="shouldValidate" [class.no-validate-input]="!shouldValidate" [class.checked]="value">
                <label *ngIf="labelPlacement === 'above'" for="{{identifier}}">
                    {{ label }}
                    <span *ngIf="required && config.showRequiredAsterisk">*</span>
                </label>
                <div></div>
                <div (click)="nextState()" (keyup.enter)="nextState()" (keyup.space)="nextState()" class="input-group check-container ng-control"
                     tabindex="0"
                     #element
                     [ngClass]="{'ng-invalid': isInvalid$() | async, 'ng-touched':(touched$ | async), 'ng-valid':!(isInvalid$() | async) && (touched$ | async)}">
                    <div class="form-control" *ngIf="labelPlacement === 'before'">
                        <label>
                            {{ label }}
                            <span *ngIf="required && config.showRequiredAsterisk">*</span>
                        </label>
                    </div>
                    <div [class.input-group-prepend]="labelPlacement === 'before'" [class.input-group-append]="labelPlacement === 'after'">
                        <div class="input-group-text">
                            <input readonly #checkbox type="checkbox"
                                   [id]="identifier"
                                   [disabled]="disabled"
                                   [(ngModel)]="value"
                                   tabindex="-1"/>
                        </div>
                    </div>
                    <div class="form-control" *ngIf="labelPlacement === 'after'">
                        <label>
                            {{ label }}
                            <span *ngIf="required && config.showRequiredAsterisk">*</span>
                        </label>
                    </div>
                </div>
                <validation-messages *ngIf="(isInvalid$() | async)" [errors]="failures" [label]="label">
                </validation-messages>
            </div>
        </ng-container>
    `,
    styles: [`check-box,date-picker,email,nested-check-box,nested-list{display:block;position:relative}.validation-messages{margin-top:10px}.form-group .form-control.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.form-group .alert-danger ul{margin-bottom:0}.form-group .form-control{width:auto}.form-group .input-group{width:auto;white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;border-radius:.25em;border:1px solid #ccc;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.form-group .input-group .form-control{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;border-top-left-radius:0;border-bottom-left-radius:0;border:none;white-space:normal}.form-group .input-group input.form-control:first-child{border-top-left-radius:.25em;border-bottom-left-radius:.25em}.form-group .input-group .input-group-text{border-style:none;border-radius:0 .25em .25em 0}.form-group .input-group .input-group-append,.form-group .input-group .input-group-prepend{border-top:none;border-bottom:none}.form-group .input-group .input-group-append:first-child,.form-group .input-group .input-group-prepend:first-child{border-bottom:none;border-left:none;border-right:1px solid #ccc}.form-group .input-group .input-group-prepend .input-group-text{border-radius:0}.form-group .input-group.full-width .input-group-append,.form-group .input-group.full-width .input-group-prepend{width:100%}.form-group .input-group.full-width .form-control,.form-group .input-group.full-width .ng-control,.form-group .input-group.full-width .ng-select{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.form-group .input-group .input-group-prepend+.ng-select{margin-left:1px}.form-group .form-control label{margin-bottom:0;line-height:24px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.form-group .d-flex>radio{margin-right:10px}.form-group .d-flex>radio:last-child{margin-right:0}.validate-input .input-group .ng-control,.validate-input .input-group.ng-control,.validate-input .ng-control,.validate-input.ng-control{border:1px solid #ccc;border-left:5px solid #ccc}.validate-input .input-group .ng-control.ng-valid:not(form).ng-touched,.validate-input .input-group.ng-control.ng-valid:not(form).ng-touched,.validate-input .ng-control.ng-valid:not(form).ng-touched,.validate-input.ng-control.ng-valid:not(form).ng-touched{border-left:5px solid #42a948}.validate-input .input-group .ng-control.ng-invalid:not(form).ng-touched,.validate-input .input-group.ng-control.ng-invalid:not(form).ng-touched,.validate-input .ng-control.ng-invalid:not(form).ng-touched,.validate-input.ng-control.ng-invalid:not(form).ng-touched{border-left:5px solid #a94442}.validate-input .input-group .ng-control .ng-control,.validate-input .input-group.ng-control .ng-control,.validate-input .ng-control .ng-control,.validate-input.ng-control .ng-control{border:none}.validate-input .input-group .no-validate-input .input-group,.validate-input .no-validate-input .input-group{border:1px solid #ccc}.validate-input .input-group .no-validate-input .input-group.ng-invalid:not(form).ng-touched,.validate-input .input-group .no-validate-input .input-group.ng-valid:not(form).ng-touched,.validate-input .no-validate-input .input-group.ng-invalid:not(form).ng-touched,.validate-input .no-validate-input .input-group.ng-valid:not(form).ng-touched{border-left:1px solid #ccc}.validate-input .input-group .no-validate-input .input-group .ng-control,.validate-input .no-validate-input .input-group .ng-control{border:none}.validate-input .form-control-container>.ng-control,.validate-input .input-group .form-control-container>.ng-control{border:1px solid #ccc;border-left:5px solid #ccc}.validate-input .form-control-container.ng-valid:not(form).ng-touched>.ng-control,.validate-input .input-group .form-control-container.ng-valid:not(form).ng-touched>.ng-control{border-left:5px solid #42a948}.validate-input .form-control-container.ng-invalid:not(form).ng-touched>.ng-control,.validate-input .input-group .form-control-container.ng-invalid:not(form).ng-touched>.ng-control{border-left:5px solid #a94442}.full-width .form-group .form-control,.full-width .form-group .input-group{width:100%}.full-width .form-group .input-group .form-control,.full-width .form-group .ng-select{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}check-box{position:relative}check-box input[type=checkbox]{pointer-events:none}check-box .check-container.label-above{display:inline-block}check-box .check-container.label-above .input-group-append,check-box .check-container.label-above .input-group-prepend{width:inherit;display:inline-block}`],
    providers    : [
        {
            provide    : NG_VALUE_ACCESSOR,
            useExisting: CheckBoxComponent,
            multi      : true
        }
    ],
    encapsulation: ViewEncapsulation.None
})
export class CheckBoxComponent extends NgFormControl<any> implements OnInit, OnDestroy {

    @OnChange @Input() state = 'off';

    @Input() name: string                = '';
    @Input() label: string               = '';
    @Input() labelPlacement: string      = 'above';
    @Input() checkedValue: any           = true;
    @Input() disabled: boolean           = false;
    @Input() shouldValidate: boolean     = true;
    @OnChange @Input() required: boolean = false;
    @Input() parentFormControl: FormControl;
    @Input() parentFormGroup: FormGroup;
    @OnChange @Input() threeState        = false;

    @Output() threeStateChange = new EventEmitter<boolean>();
              requiredChange   = new EventEmitter<boolean>();
    @Output() stateChange      = new EventEmitter<string>();

    identifier = `check-box-${identifier++}`;

    @ViewChild('checkbox') checkbox;
    @ViewChild('element') element;

    @Output() onInit = new EventEmitter<any>();

    requiredValidator: RequiredValidator = new RequiredCheckBoxValidator();

    constructor(@Inject(Injector) public injector: Injector, public config: FormConfig) {
        super(injector);
        this.additionalValidators = [this.requiredValidator];
    }

    ngOnInit() {
        super.ngOnInit();
        this.onInit.emit();
        this.requiredValidator.required = this.required;
        this.requiredChange.merge(this.stateChange).merge(this.threeStateChange).takeUntil(this.onDestroy$).subscribe(() => {
            this.requiredValidator.required = this.required;
            this.updateState();
            this.value = this.state === 'on' ? this.checkedValue : false;
        });
        this.updateState();
        Observable.interval(1000)
            .map(() => this.value)
            .distinctUntilChanged()
            .takeUntil(this.onDestroy$)
            .subscribe(() => this.updateState());
    }

    nextState() {
        if (!this.disabled) {
            this.control.markAsTouched();
            if (this.threeState && this.state === 'on') {
                this.state = 'indeterminate';
                return;
            }
            this.state = this.state === 'off' ? 'on' : 'off';
        }
    }

    updateState() {
        setTimeout(() => {
            this.correctState();
            if (this.checkbox && this.checkbox.nativeElement) {
                this.checkbox.nativeElement.indeterminate = this.state === 'indeterminate';
            }
            this.value = this.state === 'on' ? this.checkedValue : false;
        });
    }

    correctState() {
        if (this.value && this.state === 'off') {
            this.state = 'on';
        }
        if ((this.state === 'on' && !this.value) || (this.state === 'indeterminate' && !this.threeState)) {
            this.state = 'off';
        }
    }
}

let identifier = 0;
